module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v("Наименование" + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('thead', [_vm._l((_vm.sortedClients), function(client) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/users/client/' + client.id
      }
    }, [_vm._v(_vm._s(client.name))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.canDelete(_vm.permissionKey)
      },
      on: {
        "click": function($event) {
          return _vm.removeClient(client)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), (_vm.canCreate(_vm.permissionKey)) ? _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newClient.name),
      expression: "newClient.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите наименование клиента"
    },
    domProps: {
      "value": (_vm.newClient.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newClient, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.addClient
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Добавить клиента")])])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b64b2f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/clientes/Clientes.vue
// module id = 465
// module chunks = 40